import loginReducer, { modReducer } from "./sec/reducer";

const initState = {};

export default (state = initState, action) => {
    return {
        ...state,
        user: loginReducer(state.user, action),
        mod: modReducer(state.mod, action),
    };
};
